module.exports = __webpack_public_path__ + "img/document.747e2537.svg";